import { useLang } from '../lib/lang';
import { IMAGES } from '../content/constants';
import { Page, HeroShell, Reveal, Overline } from '../components/motion';
import { SkeletonGrid, CTASection, PageSection } from '../components/blocks';

export default function Service() {
  const { t } = useLang();
  const c = t.service;
  return (
    <Page meta={{ ...t.meta.service, lang: t.lang }}>
      <HeroShell testId="service-hero" overline={c.hero.overline} lines={c.hero.lines} sub={c.hero.sub} image={IMAGES.circuit} />

      <PageSection overline={c.offerings.overline} testId="service-offerings">
        <SkeletonGrid items={c.offerings.items} cols="md:grid-cols-2 lg:grid-cols-3" numbered testId="service-offerings-grid" />
      </PageSection>

      <section data-testid="service-noc" className="border-t border-white/10 bg-surface/40 blueprint">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <div className="border border-volt/30 bg-obsidian/80 backdrop-blur p-10 md:p-16 relative overflow-hidden">
              <div className="absolute inset-0 spotlight" aria-hidden="true" />
              <div className="relative">
                <div className="flex items-center gap-3">
                  <span className="w-2.5 h-2.5 rounded-full bg-volt animate-pulse-volt" aria-hidden="true" />
                  <Overline className="!mb-0">{c.noc.overline}</Overline>
                </div>
                <h2 className="mt-6 font-display text-3xl md:text-5xl font-black tracking-tight text-white uppercase">{c.noc.title}</h2>
                <p className="mt-5 max-w-2xl text-base text-zinc-400 leading-relaxed">{c.noc.body}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="service-why" className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-36">
          <Overline>{c.why.overline}</Overline>
          <Reveal>
            <p className="mt-8 font-display text-2xl md:text-4xl font-bold tracking-tight leading-snug text-white max-w-4xl">
              {c.why.body}
            </p>
          </Reveal>
        </div>
      </section>

      <CTASection title={c.cta} btn={c.cta} />
    </Page>
  );
}
